<!-- terms-of-service-page.component.html -->

<div class="terms-page-container">
  <div class="page-top-section">
    <a routerLink="/" class="back-to-home-link">← Back to Home</a>
    <img src="assets/images/logo/Dashboardly-logo.svg" alt="Dashboardly" class="centered-logo" />
  </div>

  <div class="terms-page-header">
    <div class="terms-page-title">
      <h1>Terms of Service</h1>
      <p class="updated-date">Effective Date: {{ effectiveDate }}</p>
      <p class="updated-date">Last Updated: {{ lastUpdated }}</p>
    </div>
    <div class="terms-page-actions">
      <button class="btn-print" (click)="printTerms()">
        <i class="fa fa-print"></i>
        Print
      </button>
    </div>
  </div>

  <div class="terms-page-content">
    <div class="terms-main-content">
      <div class="terms-section">
        <h2>1. INTRODUCTION</h2>
        <p>
          These Terms of Service ("Terms") govern your access to and use of the services provided by DASHBOARDLY INC, a
          Delaware corporation with its principal mailing address at 800 SE 4th Ave Ste 711, Hallandale Beach, FL 33009,
          USA ("Dashboardly," "we," "our," or "us").
        </p>
        <p>
          By accessing or using our website (https://dashboardly.io), web application, or any integrations with TikTok
          Shop or TikTok Ads (collectively, the "Service"), you agree to these Terms. If you do not agree, do not access
          or use the Service.
        </p>
      </div>

      <div class="terms-section">
        <h2>2. ELIGIBILITY & ACCOUNT REGISTRATION</h2>
        <h3>2.1 Business Use</h3>
        <p>
          The Service is designed for commercial use by TikTok Shop sellers, brands, and agencies. You must be at least
          18 years old and authorized to bind your business.
        </p>

        <h3>2.2 Account Creation</h3>
        <p>
          You must provide accurate and complete information and maintain its accuracy. You are responsible for
          safeguarding your credentials.
        </p>

        <h3>2.3 Authorized Users</h3>
        <p>
          Accounts may include multiple users (seats). You are responsible for ensuring that all users comply with these
          Terms.
        </p>
      </div>

      <div class="terms-section">
        <h2>3. LICENSE & ACCESS</h2>
        <h3>3.1 Grant of License</h3>
        <p>
          Subject to these Terms, Dashboardly grants you a limited, non-exclusive, non-transferable, revocable license
          to access and use the Service for your internal business purposes.
        </p>

        <h3>3.2 Restrictions</h3>
        <p>
          Except as expressly permitted, you may not (i) reproduce, distribute, or create derivative works; (ii) reverse
          engineer or decompile; (iii) use the Service for time-sharing or reselling except as expressly permitted for
          agencies under applicable plans.
        </p>

        <h3>3.3 Third-Party Platforms</h3>
        <p>
          Use of TikTok Shop and TikTok Ads remains subject to their respective terms. We are not liable for the
          availability or accuracy of third-party platforms.
        </p>
      </div>

      <div class="terms-section">
        <h2>4. ACCEPTABLE USE</h2>
        <p>You agree not to:</p>
        <ul>
          <li>Violate laws, regulations, or TikTok developer policies.</li>
          <li>Upload viruses, malware, or malicious code.</li>
          <li>Interfere with or disrupt the Service or its infrastructure.</li>
          <li>Attempt unauthorized access to non-public systems.</li>
          <li>
            Use TikTok-derived data to create competing datasets or analytics products in violation of TikTok policies.
          </li>
        </ul>
      </div>

      <div class="terms-section">
        <h2>5. SUBSCRIPTIONS & BILLING</h2>
        <h3>5.1 Plans</h3>
        <p>Plans, limits, and overage policies are posted at https://dashboardly.io/pricing.</p>

        <h3>5.2 Fees</h3>
        <p>
          All fees are billed in advance, monthly or annually. Overage charges apply where usage exceeds plan limits and
          are subject to plan-specific CAPs.
        </p>

        <h3>5.3 Auto-Renewal</h3>
        <p>Unless canceled, subscriptions automatically renew.</p>

        <h3>5.4 Taxes</h3>
        <p>All fees exclude taxes; you are responsible for applicable taxes.</p>

        <h3>5.5 Refunds</h3>
        <p>Except as required by law, payments are non-refundable.</p>

        <h3>5.6 Free Trial</h3>
        <p>Free trials (currently 14 days) convert to paid unless canceled before the trial ends.</p>
      </div>

      <div class="terms-section">
        <h2>6. DATA OWNERSHIP & PRIVACY</h2>
        <h3>6.1 Your Data</h3>
        <p>
          You retain ownership of the data you provide or connect (e.g., TikTok orders, products, inventory, advertising
          spend).
        </p>

        <h3>6.2 License</h3>
        <p>
          You grant Dashboardly a limited license to process and display Your Data solely for providing the Service.
        </p>

        <h3>6.3 Privacy Policy</h3>
        <p>Our data practices are detailed in the Privacy Policy.</p>

        <h3>6.4 Data Deletion</h3>
        <p>
          Upon uninstall or verified request, TikTok-derived data is deleted within 30 days; backups within 60 days. See
          Data Deletion Policy.
        </p>

        <h3>6.5 Security</h3>
        <p>
          We employ industry-standard safeguards (TLS, AES-256, RBAC, audit logs, monitoring via Sentry and Datadog).
        </p>
      </div>

      <div class="terms-section">
        <h2>7. SERVICE AVAILABILITY & SUPPORT</h2>
        <h3>7.1 Availability</h3>
        <p>We aim for reliable uptime; enterprise plans may include a 99.9% SLA.</p>

        <h3>7.2 Maintenance</h3>
        <p>Planned downtime may occur; notice will be provided when feasible.</p>

        <h3>7.3 Support</h3>
        <p>Available by email at hello&#64;dashboardly.io.</p>
      </div>

      <div class="terms-section">
        <h2>8. INTELLECTUAL PROPERTY</h2>
        <h3>8.1 Ownership</h3>
        <p>Dashboardly retains all rights in the Service, including software, designs, and trademarks.</p>

        <h3>8.2 Feedback</h3>
        <p>You grant us a perpetual, royalty-free license to use any feedback or suggestions without restriction.</p>
      </div>

      <div class="terms-section">
        <h2>9. CONFIDENTIALITY</h2>
        <p>
          Each party agrees to maintain the confidentiality of non-public information received from the other and to use
          such information only as necessary to fulfill obligations under these Terms.
        </p>
      </div>

      <div class="terms-section">
        <h2>10. BETA FEATURES</h2>
        <p>
          Certain features may be labeled "beta" or "preview." These are provided "as is" without warranty and may be
          withdrawn at any time.
        </p>
      </div>

      <div class="terms-section">
        <h2>11. DISCLAIMERS</h2>
        <p>
          THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE." TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE DISCLAIM ALL
          WARRANTIES, EXPRESS OR IMPLIED, INCLUDING MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND
          NON-INFRINGEMENT. WE DO NOT GUARANTEE THAT THE SERVICE WILL BE ERROR-FREE, UNINTERRUPTED, OR THAT THIRD-PARTY
          DATA (E.G., TIKTOK) WILL BE AVAILABLE OR ACCURATE.
        </p>
      </div>

      <div class="terms-section">
        <h2>12. LIMITATION OF LIABILITY</h2>
        <p>TO THE MAXIMUM EXTENT PERMITTED BY LAW:</p>
        <ul>
          <li>WE SHALL NOT BE LIABLE FOR INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES.</li>
          <li>
            OUR TOTAL LIABILITY FOR ALL CLAIMS IN ANY 12-MONTH PERIOD SHALL NOT EXCEED THE AMOUNTS PAID BY YOU FOR THE
            SERVICE IN THAT PERIOD.
          </li>
        </ul>
      </div>

      <div class="terms-section">
        <h2>13. INDEMNIFICATION</h2>
        <p>
          You agree to indemnify and hold harmless Dashboardly, its affiliates, and employees against any claims,
          damages, or expenses arising from (i) Your Data, (ii) your use of the Service, (iii) violation of these Terms,
          or (iv) violation of applicable law or third-party rights.
        </p>
      </div>

      <div class="terms-section">
        <h2>14. SUSPENSION & TERMINATION</h2>
        <h3>14.1 Suspension</h3>
        <p>We may suspend access if necessary for legal compliance, security, non-payment, or breach of these Terms.</p>

        <h3>14.2 Termination by You</h3>
        <p>You may terminate at any time via account settings.</p>

        <h3>14.3 Termination by Us</h3>
        <p>We may terminate immediately upon notice for uncured material breach.</p>

        <h3>14.4 Effect</h3>
        <p>Upon termination, Your Data is deleted consistent with the Data Deletion Policy.</p>
      </div>

      <div class="terms-section">
        <h2>15. EXPORT CONTROLS & SANCTIONS</h2>
        <p>
          You represent you are not subject to U.S. sanctions and will not use the Service in violation of U.S. export
          laws.
        </p>
      </div>

      <div class="terms-section">
        <h2>16. U.S. GOVERNMENT RIGHTS</h2>
        <p>
          If used by U.S. Government end users, the Service is provided as "Commercial Computer Software" subject to
          restricted rights.
        </p>
      </div>

      <div class="terms-section">
        <h2>17. GOVERNING LAW & DISPUTE RESOLUTION</h2>
        <h3>17.1 Governing Law</h3>
        <p>
          These Terms are governed by the laws of the State of Delaware, USA, without regard to conflict of law rules.
        </p>

        <h3>17.2 Venue</h3>
        <p>Exclusive venue lies in the state and federal courts of Delaware.</p>

        <h3>17.3 Waivers</h3>
        <p>To the maximum extent permitted, you waive rights to class actions and jury trials.</p>
      </div>

      <div class="terms-section contact-section" id="contact">
        <h2>18. NOTICES & CONTACT</h2>
        <p>All notices must be in writing and sent to:</p>
        <div class="contact-details">
          <address>
            <div class="company-name">Dashboardly Inc.</div>
            <div class="address-line">800 SE 4TH AVE STE 711</div>
            <div class="address-line">Hallandale Beach, FL 33009</div>
            <div class="contact-line">
              <span>Email:</span>
              <a href="mailto:hello@dashboardly.io">hello&#64;dashboardly.io</a>
            </div>
            <div class="contact-line">
              <span>Phone:</span>
              <a href="tel:+17866363699">+1 (786) 636-3699</a>
            </div>
            <div class="contact-line">
              <span>Website:</span>
              <a href="https://dashboardly.io" target="_blank">https://dashboardly.io</a>
            </div>
          </address>
        </div>
        <p class="terms-agreement">Questions? Contact us at hello&#64;dashboardly.io</p>
      </div>
    </div>

    <div class="terms-sidebar">
      <div class="sidebar-section">
        <h3>Have a question?</h3>
        <p>
          If you have any questions about this agreement, please visit our
          <a routerLink="/">homepage</a>
          or
          <a (click)="scrollToContact($event); $event.preventDefault()">contact us</a>
          .
        </p>
      </div>

      <div class="sidebar-section">
        <h3>Need more info?</h3>
        <ul class="sidebar-links">
          <li><a href="/privacy" target="_blank">Privacy Policy</a></li>
          <li><a href="/agreement" target="_blank">Agreement</a></li>
          <li><a (click)="scrollToContact($event); $event.preventDefault()">Contact Us</a></li>
        </ul>
      </div>
    </div>
  </div>
</div>
